export default __webpack_public_path__ + "static/life-2-c0b24fe37182e6f22c0fa76fe923e4cd.png";